export type PhoneCountry = "US" | "CA" | "MX";

export interface PhoneCountryOption {
	code: PhoneCountry;
	dialCode: string;
}

// Countries supported by mobile-number login, in display order.
export const PHONE_COUNTRIES: PhoneCountryOption[] = [
	{ code: "US", dialCode: "+1" },
	{ code: "CA", dialCode: "+1" },
	{ code: "MX", dialCode: "+52" },
];
